<template>
  <div>
    <svg class="space-d3-radar" :id="fundID"></svg>
    <svg width="0" height="0" v-if="comparePage">
      <defs>
        <linearGradient id="grad">
          <stop offset="0" stop-color="#1cb5e0"></stop>
        </linearGradient>
      </defs>
    </svg>
    <svg width="0" height="0" v-else>
      <defs>
        <linearGradient id="grad">
          <stop offset="0" stop-color="#1cb5e0"></stop>
          <stop offset="1" stop-color="#000046"></stop>
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import * as d3 from "d3";
import RadarJs from "../../../utils/radar-chart.js";

export default {
  name: "space-d3-radar",
  props: {
    fundID: {
      type: String,
      default: null
    },
    fundColor: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
    idx: {
      type: Number,
      default: null
    },
    comparePage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("compare", ["getCompareFundNameList"]),
    InitD3RadarObject() {
      let axes = [];
      let dataD3Radar = this.data;
      if (this.data && this.data !== undefined) {
        axes.push(
          {
            axis: "Maximum Drawdown",
            value: dataD3Radar.dd.fund,
            rankLevel: dataD3Radar.dd.text,
            Average: dataD3Radar.dd.avg
          },
          {
            axis: "Risk Adjusted Return",
            value: dataD3Radar.rr.fund,
            rankLevel: dataD3Radar.rr.text,
            Average: dataD3Radar.rr.avg
          },
          {
            axis: "Past Performance",
            value: dataD3Radar.pp.fund,
            rankLevel: dataD3Radar.pp.text,
            Average: dataD3Radar.pp.avg
          }
        );
      }
      return axes;
    },
    InitDataD3Set() {
      let axes = this.InitD3RadarObject;
      let data = [];
      data.push({
        className: "fin3d",
        axes: axes.map(function(axis) {
          return {
            axis: axis.axis,
            value: axis.value,
            rankLevel: axis.rankLevel,
            Average: axis.Average
          };
        })
      });
      return data;
    }
  },
  methods: {
    ...mapActions("fund", ["getFundD3RadarData"]),
    updateD3RadarObject() {
      let axes = [];
      let dataD3Radar = this.data;

      if (dataD3Radar.length !== 0 && dataD3Radar !== undefined) {
        axes.push(
          {
            axis: "Maximum Drawdown",
            value: dataD3Radar.dd.fund,
            rankLevel: dataD3Radar.dd.text,
            Average: dataD3Radar.dd.avg
          },
          {
            axis: "Risk Adjusted Return",
            value: dataD3Radar.rr.fund,
            rankLevel: dataD3Radar.rr.text,
            Average: dataD3Radar.rr.avg
          },
          {
            axis: "Past Performance",
            value: dataD3Radar.pp.fund,
            rankLevel: dataD3Radar.pp.text,
            Average: dataD3Radar.pp.avg
          }
        );
      }

      let data = [];
      data.push({
        className: "fin3d",
        axes: axes.map(function(axis) {
          return {
            axis: axis.axis,
            value: axis.value,
            rankLevel: axis.rankLevel,
            Average: axis.Average
          };
        })
      });
      let RadarChart = RadarJs.RadarChart;

      RadarChart.defaultConfig.radius = 3;
      RadarChart.defaultConfig.w = 300;
      RadarChart.defaultConfig.h = 300; //
      RadarChart.defaultConfig.componentId = this.fundID;
      RadarChart.defaultConfig.componentColor = this.fundColor;

      let chart = RadarChart.chart();
      let cfg = chart.config(); // retrieve default config
      let svg = d3
        .select("#" + this.fundID)
        .attr("width", "100%")
        .attr("height", "228")
        .attr("viewBox", "0 0 300 300");
      svg
        .append("g")
        .classed("single", true)
        .datum(data)
        .call(chart);
      chart.config({
        w: cfg.w / 4,
        h: cfg.h / 4,
        axisText: false,
        levels: 0,
        circles: false
      });
      cfg = chart.config();

      // d3.select('.radar-chart').remove()

      RadarChart.defaultConfig.levelTick = true;
      RadarChart.draw(".chart-container", axes);
    }
  },
  watch: {
    data(to, from) {
      this.updateD3RadarObject();
    }
  },
  async mounted() {
    let RadarChart = RadarJs.RadarChart;

    RadarChart.defaultConfig.radius = 3;
    RadarChart.defaultConfig.w = 300;
    RadarChart.defaultConfig.h = 300;
    RadarChart.defaultConfig.componentId = this.fundID;
    RadarChart.defaultConfig.componentColor = this.fundColor;

    let chart = RadarChart.chart();
    let cfg = chart.config(); // retrieve default config
    let svg = d3
      .select("#" + this.fundID)
      .attr("width", "100%")
      .attr("height", "228")
      .attr("viewBox", "0 0 300 300");
    svg
      .append("g")
      .attr("id", this.fundID)
      .classed("single", true)
      .datum(this.InitDataD3Set)
      .call(chart);
    chart.config({
      w: cfg.w / 4,
      h: cfg.h / 4,
      axisText: false,
      levels: 0,
      circles: false
    });
    cfg = chart.config();

    RadarChart.defaultConfig.levelTick = true;
    RadarChart.draw(".chart-container", this.InitD3RadarObject);
  }
};
</script>


<style lang="scss" scope>
</style>

<style lang="scss">
.bg-color {
  fill: #ddd;
}

.level-group-1 {
  .level {
    stroke: rgb(22, 22, 22);
    stroke-dasharray: 3;
    stroke-width: 1px;
  }
}

.axis {
  line {
    stroke: #fff;
    stroke-width: 2px;
    display: block;
  }
  .legend-radar {
    font-family: sans-serif;
    font-size: 13px;
    &.top {
      dy: 1em;
    }
    &.left {
      text-anchor: start;
    }
    &.middle {
      text-anchor: middle;
    }
    &.right {
      text-anchor: end;
    }
    &.green {
      fill: green;
    }
    &.red {
      fill: orange;
    }
  }
}

.tooltip {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
  font-family: sans-serif;
  font-size: 13px;
  transition: opacity 200ms;
  opacity: 0;
}

.visible {
  opacity: 1;
}

.area {
  fill: url(#grad);
  stroke-width: 2;
  fill-opacity: 0.7;
  transition: opacity 300ms, fill-opacity 200ms;
  opacity: 1;
  .fin3d {
    stroke: none;
    .circle {
      fill: #fff;
      stroke: rgb(31, 119, 180);
    }
  }
}

.area-average {
  stroke-width: 2;
  fill-opacity: 0;
  opacity: 1;
  stroke: #888;
  fill: #ddd;
  stroke-dasharray: 3;
}

.circle {
  fill-opacity: 0.9;
  transition: opacity 300ms, fill-opacity 200ms;
  opacity: 1;
}

.focus {
  .area {
    fill-opacity: 0.3;
    .focused {
      fill-opacity: 0.9;
    }
  }
}
</style>

